import React from "react"
import { Box, Typography, Paper } from "@mui/material"

const ChartTooltip = ({ title, stats, position }) => {
  if (!position) return null

  const getDotColor = (rawLabel) => {
    if (typeof rawLabel !== "string") return null
    const label = rawLabel.toLowerCase()
    if (label.includes("agent 1")) return "#148DFD"
    if (label.includes("agent 2")) return "#FA8C16"
    if (label.includes("agent 3")) return "#52C41A"
    if (label.includes("agent 5")) return "#5CDBD3"
    if (label.includes("agent 4")) return "#9254DE"
    if (label.includes("positive")) return "#52C41A"
    if (label.includes("negative")) return "#FF4D4F"
    if (label.includes("new") && label.includes("ticket")) return "#148DFD"
    if (label.includes("resolved")) return "#52C41A"
    if (label.includes("handled")) return "#148DFD"
    if (label.includes("missed")) return "#FF4D4F"
    if (label.includes("solved") && label.includes("ticket")) return "#52C41A"


    return null
  }

  const DOT_SIZE_PX = 8
  const DOT_GAP_PX = 6

  const renderDot = (label) => {
    const fill = getDotColor(label)
    if (!fill) return null

    return (
      <Box
        component="span"
        aria-hidden
        sx={{
          display: "inline-block",
          width: `${DOT_SIZE_PX}px`,
          height: `${DOT_SIZE_PX}px`,
          borderRadius: "50%",
          backgroundColor: fill,
          marginRight: `${DOT_GAP_PX}px`,
          flexShrink: 0,
        }}
      />
    )
  }

  return (
    <Paper
      sx={{
        position: "fixed",
        left: position.x,
        top: position.y,
        transform: "translate(-50%, -100%)",
        borderRadius: "8px",
        border: "1px solid #D5DCE1",
        backgroundColor: "#FFF",
        boxShadow: "0 15px 20px 0 rgba(6, 21, 34, 0.05)",
        padding: "16px",
        zIndex: 1000,
        minWidth: "168px",
        pointerEvents: "none",
      }}
    >
      <Typography
        sx={{
          color: "#061522",
          fontFamily: "Inter",
          fontSize: "16px",
          fontWeight: 500,
          lineHeight: "18px",
          marginBottom: "16px",
        }}
      >
        {title}
      </Typography>

      {stats.map((stat, index) => {
        const hasDot = !!getDotColor(stat.label)
        return (
          <Box key={index} sx={{ marginBottom: "8px", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            <Typography
              component="span"
              sx={{
                color: "#405261",
                fontFamily: "Inter",
                fontSize: "12px",
                fontWeight: 400,
                lineHeight: "18px",
                marginRight: "8px",
                display: "flex",
                alignItems: "center",
                marginBottom: "6px",
                textTransform: "capitalize",

              }}
            >
              {renderDot(stat.label)}
              {stat.label}
            </Typography>
            <Typography
              component="span"
              sx={{
                color: "#061522",
                fontFamily: "Inter",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "18px",
                ...(hasDot && { marginLeft: `${DOT_SIZE_PX + DOT_GAP_PX}px` }),
              }}
            >
              {stat.value}
            </Typography>
          </Box>
        )
      })}
    </Paper>
  )
}

export default ChartTooltip